// extracted by mini-css-extract-plugin
export default {"container":"styles_container__HfXh6","title":"styles_title__ayQKk","img":"styles_img__IRZbb"};